import axios from 'axios';
import * as actions from './constFetch';

const initialState = {
  loading: false,
  datas: [],
  error: '',
};

const fetchDatas = () => {
  return {
    type: actions.FETCH_DATAS_REQUEST,
  };
};

const fetchDatasSuccess = (datas) => {
  return {
    type: actions.FETCH_DATAS_SUCCESS,
    payload: datas,
  };
};

const fetchDatasError = (error) => {
  return {
    type: actions.FETCH_DATAS_FAILURE,
    payload: error,
  };
};

const fetch = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_DATAS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_DATAS_SUCCESS:
      return {
        loading: false,
        datas: action.payload,
        error: '',
      };
    case actions.FETCH_DATAS_FAILURE:
      return {
        loading: false,
        datas: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const fetchData = () => {
  return (dispatch) => {
    dispatch(fetchDatas());
    axios
      .get('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        // response.data is the users
        const users = response.data;
        dispatch(fetchDatasSuccess(users));
      })
      .catch((error) => {
        // error.message is the error message
        dispatch(fetchDatasError(error.message));
      });
  };
};
export default fetch;
